import React from 'react'
import Markdown from 'react-markdown/with-html'
import classnames from 'classnames'

import { string } from 'prop-types'

const LinkRenderer = (props) => {
  const isQuipperLink = props.href.indexOf('quipper.com') >= 0
  const isQuipperCampus = props.href.indexOf('campus.quipper.com') >= 0

  const getLinkAttr = () => {
    if (isQuipperLink) {
      if (!isQuipperCampus) {
        return ({ target: '_blank', rel: 'noopener' })
      }
      return ({})
    }
    return ({
      target: '_blank',
      rel: 'nofollow noopener',
    })
  }

  return (
    <a href={props.href} {...getLinkAttr()}>
      {props.children}
    </a>
  )
}

LinkRenderer.propTypes = {
  href: string,
}

export { LinkRenderer }

const MarkdownContent = ({ content, className }) => (
  <>
    <Markdown
      className={classnames('cmps-markdown', className)}
      renderers={{ link: LinkRenderer }}
      source={content}
      escapeHtml={false}
    />
    <style jsx global>
      {`
        .cmps-markdown {
          p {
            font-size: 16px;
            line-height: 2;
            margin-bottom: 1.5rem;
          }
          li {
            font-size: 16px;
            line-height: 2;
          }
          ol + ul {
            padding-left: 60px;
          }
        }
        .truncate {
          p {
            overflow: hidden;
            position: relative;
            line-height: 1.5em;
            max-height: 4.5em;
            margin-right: 0;
            padding-right: 1em;
          }
        }
      `}
    </style>
  </>
)

MarkdownContent.propTypes = {
  content: string,
}

export default MarkdownContent
